import Swiper from 'swiper';
import {A11y, Autoplay, EffectFade, Pagination} from 'swiper/modules';

export default class HeaderVisual {
    constructor($headerVisual) {
        const slideCount = $headerVisual.querySelectorAll('.swiper-slide').length;

        this.swiper = new Swiper($headerVisual, {
            modules: [A11y, Autoplay, EffectFade, Pagination],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: slideCount > 1,
            speed: 500,
            allowTouchMove: slideCount > 1,
            autoplay: slideCount > 1 ? {
                delay: 7000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false,
            pagination: {
                el: $headerVisual.querySelector('[data-header-visual-pagination]'),
                bulletClass: 'header-visual__indicator',
                bulletActiveClass: 'header-visual__indicator--active',
                clickable: slideCount > 1,
                renderBullet: (index, className) => (
                    slideCount > 1
                        ? `<button class="${className}" type="button"></button>`
                        : `<span class="${className}" aria-hidden="true"></span>`
                ),
            },
            a11y: {
                containerMessage: $headerVisual.dataset.headerVisualLabel,
                containerRoleDescriptionMessage: $headerVisual.dataset.headerVisualRole,
                itemRoleDescriptionMessage: $headerVisual.dataset.headerVisualSlideRole,
                paginationBulletMessage: `${$headerVisual.dataset.headerVisualShowSlide} {{index}}`,
            },
            on: {
                init: swiper => this.updateSlideAccessibility(swiper),
                slideChange: swiper => this.updateSlideAccessibility(swiper),
            },
        });

        this.swiper.pagination.bullets.forEach(($bullet, index) => {
            $bullet.setAttribute(
                'aria-label',
                `${$headerVisual.dataset.headerVisualShowSlide} ${index + 1}`
            );
        });

        $headerVisual.addEventListener('focusin', () => this.swiper.autoplay?.pause());
        $headerVisual.addEventListener('focusout', event => {
            if (!$headerVisual.contains(event.relatedTarget)) {
                this.swiper.autoplay?.resume();
            }
        });
    }

    updateSlideAccessibility(swiper) {
        swiper.slides.forEach(($slide, index) => {
            const isActive = index === swiper.activeIndex;
            $slide.toggleAttribute('inert', !isActive);
            $slide.setAttribute('aria-hidden', String(!isActive));
        });
    }
}
